import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat',
  standalone: true
})
export class PhoneFormatPipe implements PipeTransform {
  transform(phone: string | null | undefined): string {
    if (!phone) return '—';

    // Remove all non-digit characters
    const cleaned = phone.replace(/\D/g, '');

    // Format as XXX-XXX-XXXX or XXX-XXX-XXX
    if (cleaned.length === 10) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    } else if (cleaned.length === 9) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }

    // Return original if doesn't match expected format
    return phone;
  }
}
